import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ModalContainer from './ModalContainer';

import FigoLottie from './FigoLottie';
import ForgetPasswordInput from './ForgetPasswordInput';

import warningIcon from '../../assets/alert-citron.svg';

import {
  forgetPasswordEmailChanged,
  forgetPasswordEmailErrorChanged,
  forgetPasswordVisibleChanged,
  resetPassword,
} from '../../actions';

import { validateEmail } from '../../util';

import './ModalForgetPassword.css';

const ModalForgetPassword = ({ onModalClosed = () => { } }) => {
  const store = useSelector(({ quoting }) => quoting, shallowEqual);
  const dispatch = useDispatch();
  const { sessionInformation: {
    forgetPasswordEmail,
    forgetPasswordEmailError,
    forgetPasswordModalVisible,
    forgetPasswordResetLoading,
  } } = store;
  const INVALID_EMAIL = 'Invalid email.';

  function handleEmailChanged(event) {
    const { value } = event.target;
    dispatch(forgetPasswordEmailChanged({ email: value }));
  }

  function handleEmailBlur() {
    const isEmailValid = validateEmail(forgetPasswordEmail);
    const error = isEmailValid ? '' : INVALID_EMAIL;
    dispatch(forgetPasswordEmailErrorChanged({ error }));
    return error;
  }

  function handleCloseModal() {
    dispatch(forgetPasswordVisibleChanged({ visible: false }));
    onModalClosed();
  }

  function handleResetPasswordClick() {
    const error = handleEmailBlur();

    if (!error) {
      dispatch(resetPassword({ email: forgetPasswordEmail }));
    }
  }

  function handleOnKeyPressEmail(event) {
    const ENTER_KEY = 13;
    if (event.which === ENTER_KEY) {
      handleResetPasswordClick();
    }
  }

  function renderContentButton() {
    if (forgetPasswordResetLoading) {
      return <FigoLottie />;
    }

    return 'Reset';
  }

  return (
    <ModalContainer
      cancelable={false}
      show={forgetPasswordModalVisible}
    >
      <div className="Modal-forget-password-container">
        <img
          alt="warning"
          className="Modal-forget-password-warning-icon"
          src={warningIcon}
        />

        <span className="Modal-forget-password-title">
          Reset Password
        </span>

        <span className="Modal-forget-password-description Inter-regular-16">
          Please enter your email address below.<br />
          A link will be sent to reset your password.
        </span>

        <div className="Modal-forget-password-input-container">
          <ForgetPasswordInput
            error={forgetPasswordEmailError}
            onBlur={handleEmailBlur}
            onChange={handleEmailChanged}
            onKeyPress={handleOnKeyPressEmail}
            placeholder="Required"
            title="Email Address"
            value={forgetPasswordEmail}
          />
        </div>

        <div className="Modal-forget-password-footer-container">
          <input
            className="Modal-forget-password-button-footer Inter-semi-bold-16"
            onClick={handleCloseModal}
            type="button"
            value="Cancel"
          />

          <button
            aria-label="Reset"
            className={'Modal-forget-password-button-footer-reset '
            + 'Inter-semi-bold-16'}
            onClick={handleResetPasswordClick}
            type="button"
          >
            {renderContentButton()}
          </button>
        </div>
      </div>
    </ModalContainer>
  );
};

export default ModalForgetPassword;
